import { render, staticRenderFns } from "./RedecoSearch.vue?vue&type=template&id=645ea99d&"
import script from "./RedecoSearch.vue?vue&type=script&lang=js&"
export * from "./RedecoSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports